import { FC } from 'react';
import MenuSvg from '@edikk-edikk/country-layout-black-icon/src/menu.svg';
import MenuAltSvg from '@edikk-edikk/country-layout-black-icon/src/menu-alt.svg';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import { useClassNamesWithStyle, useIsFrontendStyleRed } from '@edikk-edikk/country-frontend';
import menuControlsActionCss from '#baseMenu/assets/menu-controls-action.module.scss';

const ButtonOpenSvgIcon: FC = () => {
  const isFrontendStyleRed = useIsFrontendStyleRed();
  const classNamesWithStyle = useClassNamesWithStyle();

  if (isFrontendStyleRed) {
    return (
      <SvgIcon
        Component={MenuAltSvg}
        width={20}
        isWithoutStroke
        height={20}
        additionalClassName={classNamesWithStyle(
          menuControlsActionCss.menuControlsAction__icon,
          null,
          menuControlsActionCss.menuControlsAction__icon_styleRed,
        )}
      />
    );
  }

  return <SvgIcon Component={MenuSvg} width={20} height={20} />;
};

export { ButtonOpenSvgIcon };
